import {
	ChevronDoubleLeftIcon,
	ChevronDoubleRightIcon,
	ChevronLeftIcon,
	ChevronRightIcon,
} from "@heroicons/react/20/solid";

export default function Pagination({ itemsPerPage, items, page, setPage, loading }) {
	if (loading) return <strong>Loading...</strong>;
	if (!items?.length) return null;

	const lastPage = Math.ceil(items?.length / (itemsPerPage || 15));

	if (page > lastPage) setPage(lastPage - 1);

	return (
		<thead>
			<tr>
				<th colSpan={7}>
					<div
						style={{
							display: "grid",
							gridGap: "1.5rem",
							grid: "1.5rem",
							gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
						}}
					>
						<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
							<button
								className="btn btn-xs btn-default pull-left"
								title="Go To Page 1"
								style={{ marginLeft: "0.5rem" }}
								onClick={() => {
									if (page != 0) setPage(0);
								}}
								disabled={page === 0}
							>
								<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
							</button>
							<button
								className="btn btn-xs btn-default pull-left"
								title="Go Back 5 Pages"
								style={{ marginLeft: "0.5rem" }}
								onClick={() => {
									if (page != 0) setPage(Math.max(page - 5, 0));
								}}
								disabled={page === 0}
							>
								<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
							</button>
							<button
								className="btn btn-xs btn-default pull-left"
								title="Go Back 1 Page"
								style={{ marginLeft: "0.5rem" }}
								onClick={() => {
									if (page != 0) setPage(page - 1);
								}}
								disabled={page === 0}
							>
								<ChevronLeftIcon style={{ height: "1.5em", float: "left" }} />
							</button>
						</div>
						<div style={{ gridColumn: "span 1 / span 1", textAlign: "center" }}>
							<strong>
								Page {page + 1}/{lastPage}
							</strong>
						</div>
						<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
							<button
								className="btn btn-xs btn-default pull-right"
								style={{ marginRight: "0.5rem" }}
								title={`Go To Page ${lastPage}`}
								onClick={() => {
									if (page != lastPage - 1) setPage(lastPage - 1);
								}}
								disabled={page === lastPage - 1}
							>
								<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
							</button>
							<button
								className="btn btn-xs btn-default pull-right"
								title="Go Forward 5 Pages"
								style={{ marginRight: "0.5rem" }}
								onClick={() => {
									if (page != lastPage - 1) setPage(Math.min(page + 5, lastPage - 1));
								}}
								disabled={page === lastPage - 1}
							>
								<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
							</button>
							<button
								className="btn btn-xs btn-default pull-right"
								title="Go Forward 1 Page"
								onClick={() => {
									if (page != lastPage - 1) setPage(page + 1);
								}}
								style={{ marginRight: "0.5rem" }}
								disabled={page === lastPage - 1}
							>
								<ChevronRightIcon style={{ height: "1.5em", float: "left" }} />
							</button>
						</div>
					</div>
				</th>
			</tr>
		</thead>
	);
}
